import { createContext, ReactNode, useState } from 'react';

// project import
import { PaletteMode } from '@mui/material';
import defaultConfig from 'themeConfig';

// types

import { AvailableFontsType } from 'utils/fonts';
import { CustomBrandSettings } from 'types/dashboard-config';

// initial state
const initialState: any = {
    ...defaultConfig,
    onChangeLayout: () => {},
    onChangeDrawer: () => {},
    onChangeMenuType: () => {},
    onChangePresetColor: () => {},
    onChangeLocale: () => {},
    onChangeRTL: () => {},
    onChangeContainer: () => {},
    onChangeFontFamily: () => {},
    onChangeBorderRadius: () => {},
    onChangeOutlinedField: () => {},
    onChangeDefaultLogo: () => {},
    onChangeCustomSettings: () => {}
};

// ==============================|| CONFIG CONTEXT & PROVIDER ||============================== //

const ConfigContext = createContext(initialState);

type ConfigProviderProps = {
    children: ReactNode;
};

function ConfigProvider({ children }: ConfigProviderProps) {
    const [config, setConfig] = useState<any>({
        layout: initialState.layout,
        drawerType: initialState.drawerType,
        fontFamily: initialState.fontFamily,
        borderRadius: initialState.borderRadius,
        outlinedFilled: initialState.outlinedFilled,
        navType: initialState.navType,
        presetColor: initialState.presetColor,
        locale: localStorage.getItem('locale') || initialState.locale,
        rtlLayout: initialState.rtlLayout,
        defaultLogo: initialState.defaultLogo,
        primaryColor: initialState.primaryColor,
        secondaryColor: initialState.secondaryColor
    });

    const onChangeLayout = (layout: string) => {
        setConfig({
            ...config,
            layout
        });
    };

    const onChangeDrawer = (drawerType: string) => {
        setConfig({
            ...config,
            drawerType
        });
    };

    const onChangeMenuType = (navType: PaletteMode) => {
        setConfig({
            ...config,
            navType
        });
    };

    const onChangePresetColor = (presetColor: string) => {
        setConfig({
            ...config,
            presetColor
        });
    };

    const onChangeLocale = (locale: string) => {
        localStorage.setItem('locale', locale);
        setConfig({
            ...config,
            locale
        });
    };

    const onChangeRTL = (rtlLayout: boolean) => {
        setConfig({
            ...config,
            rtlLayout
        });
    };

    const onChangeContainer = () => {
        setConfig({
            ...config,
            container: !config.container
        });
    };

    const onChangeFontFamily = (fontFamily: AvailableFontsType) => {
        setConfig({
            ...config,
            fontFamily
        });
    };

    const onChangeBorderRadius = (event: Event, newValue: number | number[]) => {
        setConfig({
            ...config,
            borderRadius: newValue as number
        });
    };

    const onChangeOutlinedField = (outlinedFilled: boolean) => {
        setConfig({
            ...config,
            outlinedFilled
        });
    };
    const onChangeDefaultLogo = (defaultLogo: string) => {
        setConfig({
            ...config,
            defaultLogo
        });
    };

    const onChangeCustomSettings = (customSettings: CustomBrandSettings) => {
        setConfig({
            ...config,
            ...customSettings
        });
    };

    return (
        <ConfigContext.Provider
            value={{
                ...config,
                onChangeLayout,
                onChangeDrawer,
                onChangeMenuType,
                onChangePresetColor,
                onChangeLocale,
                onChangeRTL,
                onChangeContainer,
                onChangeFontFamily,
                onChangeBorderRadius,
                onChangeOutlinedField,
                onChangeDefaultLogo,
                onChangeCustomSettings
            }}
        >
            {children}
        </ConfigContext.Provider>
    );
}

export { ConfigContext, ConfigProvider };
